import api from '../../../api/index';

export default {
  register({ rootGetters }, value) {
    return api.post('/representative', value, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
};
